import { render, staticRenderFns } from "./balanceAdd.vue?vue&type=template&id=09668d09&scoped=true&"
import script from "./balanceAdd.vue?vue&type=script&lang=js&"
export * from "./balanceAdd.vue?vue&type=script&lang=js&"
import style0 from "./balanceAdd.vue?vue&type=style&index=0&id=09668d09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09668d09",
  null
  
)

export default component.exports